/* eslint-disable max-classes-per-file */
import { TicketType } from "@/libs/server/goApiServer/experience/ExperienceServiceInterface/getEventTicketAvailableInterfaces";
import { ProductTypeEnums } from "@/types/product/account/history";

import { ResponsePresenter } from "../../common/commonClassPresenter";
import { CorporateDisCountPresenter } from "../../corporate/corporateServiceInterfaces/corporateInterface";
import { ExperienceTotalTicketOfType } from "./getHistoryExperienceListInterface";
import {
  ContactDatePresenter,
  DayPlanDataPresenter,
  ExpirePaymentDatePresenter,
  PaymentChannelDataPresenter,
  PaymentCouponDiscountPresenter,
  RefundedPaymentDatePresenter,
} from "./historyBookingCommonInterface";

export interface PrivilegesDataPerksDetail {
  name: string;
  detail: string;
}
export interface HistoryExpiencePerk {
  privileges: PrivilegesDataPerksDetail[];
  freebies: PrivilegesDataPerksDetail[];
}
class ExperienceDetailPaymentPricePackage {
  type: string;

  name: string;

  amount: number;

  price: number;

  constructor(response: any) {
    this.type = response?.type || "";
    this.name = response?.name || "";
    this.amount = response?.amount || 0;
    this.price = response?.price || 0;
  }
}

export class ExperienceDetailPaymentPrice {
  totalAmount: number;

  packages: ExperienceDetailPaymentPricePackage[];

  constructor(response: any) {
    this.totalAmount = response?.totalAmount || 0;
    this.packages = (response?.packages || []).map(
      (results: any) => new ExperienceDetailPaymentPricePackage(results),
    );
  }
}

class ExperienceDetailPaymentPresenter {
  bookingDate: string;

  paymentSuccessDate: string;

  price: ExperienceDetailPaymentPrice;

  couponDiscount: PaymentCouponDiscountPresenter;

  paymentType: string;

  paymentUrl: string;

  isAllocatesExpire: boolean;

  isPaymentExpire: boolean;

  expireAllocateDate: ExpirePaymentDatePresenter;

  expirePaymentDate: ExpirePaymentDatePresenter;

  channel: PaymentChannelDataPresenter;

  refunded: RefundedPaymentDatePresenter;

  constructor(response: any) {
    this.paymentType = response?.paymentType || "";
    this.paymentUrl = response?.paymentUrl || "";
    this.isPaymentExpire = response?.isPaymentExpire || false;
    this.isAllocatesExpire = response?.isAllocatesExpire || false;
    this.expireAllocateDate = new ExpirePaymentDatePresenter(
      response?.expireAllocateDate,
    );
    this.expirePaymentDate = new ExpirePaymentDatePresenter(
      response?.expirePaymentDate,
    );
    this.channel = new PaymentChannelDataPresenter(response?.channel);
    this.couponDiscount = new PaymentCouponDiscountPresenter(
      response?.couponDiscount,
    );
    this.bookingDate = response?.bookingDate || "";
    this.paymentSuccessDate = response?.paymentSuccessDate || "";
    this.price = new ExperienceDetailPaymentPrice(response?.price);
    this.refunded = new RefundedPaymentDatePresenter(response?.refunded);
  }
}

class ExperienceDetaiLocationPresenter {
  addressFull: string;

  countryName: string;

  countrySlug: string;

  cityName: string;

  citySlug: string;

  areaName: string;

  areaSlug: string;

  latitude: number;

  longitude: number;

  constructor(response: any) {
    this.areaName = response?.areaName || "";
    this.areaSlug = response?.areaSlug || "";
    this.cityName = response?.cityName || "";
    this.citySlug = response?.citySlug || "";
    this.countryName = response?.countryName || "";
    this.countrySlug = response?.countrySlug || "";
    this.addressFull = response?.addressFull || "";
    this.latitude = response?.latitude || 0;
    this.longitude = response?.longitude || 0;
  }
}

class ExperienceReviewRatingPresenter {
  numReviews: number;

  rating: number;

  textRatingDetail: string;

  constructor(res: any) {
    this.numReviews = res?.numReviews || 0;
    this.rating = res?.rating || 0;
    this.textRatingDetail = res?.textRatingDetail || "";
  }
}
class ExperienceDetailInfoPresenter {
  name: string;

  slug: string;

  description: string;

  phone: string;

  cover: string;

  photoGallery: string[];

  isGreenCertificate: boolean;

  location: ExperienceDetaiLocationPresenter;

  reviewRating: ExperienceReviewRatingPresenter;

  packages: string;

  fax: string;

  email: string;

  // greenCertifications: any[]

  constructor(response: any) {
    this.name = response?.name || "";
    this.slug = response?.slug || "";
    this.description = response?.description || "";
    this.phone = response?.phone || "";
    this.cover = response?.cover || "";
    this.photoGallery = response?.photoGallery || [];
    this.isGreenCertificate = response?.isGreenCertificate || false;
    this.location = new ExperienceDetaiLocationPresenter(response?.location);
    this.reviewRating = new ExperienceReviewRatingPresenter(
      response?.reviewRating || {},
    );
    this.packages = response?.packages || "";
    this.fax = response?.fax || "";
    this.email = response?.email || "";
  }
}

class ExperienceDetailPackagePrice {
  id: number;

  name: string;

  type: string;

  price: number;

  currency: string;

  minPax: number;

  maxPax: number;

  frequency: string;

  fixedDates: string[];

  expirationDate: number;

  amount: number;

  netPrice: number;

  pricePerTicket: number;

  // span: any
  constructor(response: any) {
    this.id = response?.id || 0;
    this.name = response?.name || "";
    this.type = response?.type || "";
    this.price = response?.price || 0;
    this.currency = response?.currency || "";
    this.minPax = response?.minPax || 0;
    this.maxPax = response?.maxPax || 0;
    this.frequency = response?.frequency || "";
    this.fixedDates = response?.fixedDates || "";
    this.expirationDate = response?.expirationDate || 0;
    this.amount = response?.amount || 0;
    this.netPrice = response?.netPrice || 0;
    this.pricePerTicket = response?.pricePerTicket || 0;
  }
}

export class ExperienceDetailAvailable {
  ticketAvailableId: number;

  ticketType: string;

  name: string;

  ticketName: string;

  currency: string;

  price: number;

  description: string;

  duration: string;

  redeemStartOri: string;

  redeemStart: string;

  redeemEndOri: string;

  redeemEnd: string;

  round: string;

  publishStartOri: string;

  publishStart: string;

  publishEndOri: string;

  publishEnd: string;

  instantConfirm: boolean;

  total: string;

  totalAmount: string;

  answers: {
    ticketAvailableId: number;
    amount: number;
    answers: string;
  };

  packagePrice: ExperienceDetailPackagePrice;

  termsAndConditions: string;

  constructor(response: any) {
    this.ticketAvailableId = response?.ticketAvailableId || 0;
    this.ticketType = response?.ticketType || "";
    this.name = response?.name || "";
    this.currency = response?.currency || "";
    this.price = response?.price || 0;
    this.redeemStartOri = response?.redeemStartOri || "";
    this.redeemStart = response?.redeemStart || "";
    this.redeemEndOri = response?.redeemEndOri || "";
    this.redeemEnd = response?.redeemEnd || "";
    this.round = response?.round || "-";
    this.publishStart = response?.publishStart || "";
    this.publishEnd = response?.publishEnd || "";
    this.instantConfirm = response?.instantConfirm || false;
    this.total = response?.total || 0;
    this.totalAmount = response?.totalAmount || 0;
    this.publishStartOri = response?.publishStartOri || "";
    this.publishEndOri = response?.publishEndOri || "";
    this.ticketName = response?.ticketName || "";
    this.description = response?.description || "";
    this.duration = response?.duration || "-";
    this.answers = {
      ticketAvailableId: response?.answers?.ticketAvailableId || "",
      amount: response?.answers?.amount || "",
      answers: response?.answers?.answers || "",
    };
    this.packagePrice = new ExperienceDetailPackagePrice(
      response?.packagePrice,
    );
    this.termsAndConditions = response?.termsAndConditions || "";
  }
}

class ExperienceDetailAvailablePresenter {
  totalTicketsOfBooking: number;

  tier: string;

  ticketType: string;

  ticketWholesaleTicketPackageId: number;

  packageName: string[];

  totalTicketOfType: ExperienceTotalTicketOfType[];

  available: ExperienceDetailAvailable[];

  constructor(response: any) {
    this.totalTicketsOfBooking = response?.totalTicketsOfBooking || 0;
    this.tier = response?.tier || "";
    this.ticketType = response?.ticketType || "";
    this.ticketWholesaleTicketPackageId =
      response?.ticketWholesaleTicketPackageId || 0;
    this.packageName = response?.packageName || [];
    this.totalTicketOfType = (response?.totalTicketOfType || []).map(
      (results: any) => new ExperienceTotalTicketOfType(results),
    );
    this.available = (response?.available || []).map(
      (results: any) => new ExperienceDetailAvailable(results),
    );
  }
}

class ExperienceDetailQuestionPresenter {
  question: string;

  answer: string;

  constructor(res: any) {
    this.question = res?.question ?? "";
    this.answer = res?.answer ?? "";
  }
}

class ExperienceDetailDataPresenter extends CorporateDisCountPresenter {
  ticketWholesaleId: number;

  id: number;

  reservationNo: string;

  meetingPoint: string;

  pinCode: string;

  bookingInternalNo: string;

  paymentStatus: string;

  bookingStatus: string;

  bookingStep: string;

  joiningDateOri: string;

  joiningDate: string;

  price: number;

  currency: string;

  ticketWholesaleTicketId: number;

  resendVoucher: boolean;

  resendPayment: boolean;

  isCanceled: boolean;

  bookingDateOri: string;

  updatedAt: string;

  dayPlan: DayPlanDataPresenter;

  contact: ContactDatePresenter;

  payment: ExperienceDetailPaymentPresenter;

  info: ExperienceDetailInfoPresenter;

  available: ExperienceDetailAvailablePresenter;

  refundStatus: string;

  message: string;

  dateCancel: string;

  cancellationPolicy: string;

  question: Array<ExperienceDetailQuestionPresenter>;

  productType: string;

  ticketType: string;

  type: string;

  termsAndConditions: string;

  perks: HistoryExpiencePerk[];

  constructor(response: any) {
    super(response);
    this.productType = response?.productType || ProductTypeEnums.EXPERIENCE;
    this.ticketWholesaleId = response?.ticketWholesaleId || 0;
    this.id = response?.id || 0;
    this.reservationNo = response?.reservationNo || "";
    this.meetingPoint = response?.meetingPoint || "-";
    this.pinCode = response?.pinCode || "";
    this.bookingInternalNo = response?.bookingInternalNo || "";
    this.paymentStatus = (response?.paymentStatus || "").toLocaleLowerCase();
    this.bookingStatus = (response?.bookingStatus || "").toLocaleLowerCase();
    this.bookingStep = (response?.bookingStep || "").toLocaleLowerCase();
    this.joiningDateOri = response?.joiningDateOri || "";
    this.joiningDate = response?.joiningDate || "";
    this.price = response?.price || 0;
    this.currency = response?.currency || "";
    this.ticketWholesaleTicketId = response?.ticketWholesaleTicketId || 0;
    this.resendVoucher = response?.resendVoucher || false;
    this.resendPayment = response?.resendPayment || false;
    this.isCanceled = response?.isCanceled || false;
    this.bookingDateOri = response?.bookingDateOri || "";
    this.updatedAt = response?.updatedAt || "";
    this.dayPlan = new DayPlanDataPresenter(response?.dayPlan);
    this.contact = new ContactDatePresenter(response?.contact);
    this.payment = new ExperienceDetailPaymentPresenter(response?.payment);
    this.info = new ExperienceDetailInfoPresenter(response?.info);
    this.available = new ExperienceDetailAvailablePresenter(
      response?.available,
    );
    this.refundStatus = response?.refundStatus || "";
    this.message = response?.message || "";
    this.dateCancel = response?.dateCancel || "";
    this.cancellationPolicy = response?.cancellationPolicy || "";
    this.ticketType = response?.ticketType || TicketType.DAY_TRIP;
    this.type = response?.type || ProductTypeEnums.EXPERIENCE;
    this.question =
      response?.question?.map(
        (question: any) => new ExperienceDetailQuestionPresenter(question),
      ) ?? [];
    this.termsAndConditions = response?.termsAndConditions ?? "";
    this.perks = response?.perks ?? [];
  }
}
export class ResponseGetDetailExperiencePresenter extends ResponsePresenter<ExperienceDetailDataPresenter> {
  cToken: string;

  constructor(response: any) {
    super(response, (data) => new ExperienceDetailDataPresenter(data));
    this.cToken = response?.cToken || "";
  }
}
